module.exports = __webpack_public_path__ + "static/media/bedroom.d8369dc7.jpg";